import {
  currencyTypeRender,
  formatUSDNoDecimals,
  handleValidDate,
  handleValidTime,
  usdFormatter
} from '../../../helpers/helpers';

import { SetAutostakeDate } from './actions/setAutostakeDate';

import PackageOrdersActions from './actions';
import { calculationStatusForTable } from './slice';
import { Link } from 'react-router-dom';

import { getUserFromLS } from '../../../helpers/localstorage-helper';

const userFromLS = getUserFromLS();

const permissions = userFromLS?.permissions;

const baseColumns = [
  {
    id: 1,
    Header: 'Order ID',
    accessor: 'id',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },
  {
    id: 2,
    Header: 'User ID',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <Link to={`/users/${cell.value.id}`} state={{ tab: '3' }}>
          {cell.value.id}
        </Link>
      );
    }
  },
  {
    id: 3,
    Header: 'User',
    accessor: 'user',
    Cell: (cell: any) => {
      return (
        <>
          {cell.value.name} {cell.value.surname}
        </>
      );
    }
  },

  {
    id: 4,
    Header: 'Package Name',
    accessor: 'productName',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },
  {
    id: 6,
    Header: 'Amount',
    accessor: 'price',
    Cell: (cell: any) => {
      return cell?.value ? `${formatUSDNoDecimals(cell?.value)} USDT` : '---';
    }
  },

  {
    id: 7,
    Header: 'Payment address',
    accessor: 'paymentAddress',
    Cell: (cell: any) => {
      return cell?.value;
    }
  },

  {
    id: 10,
    Header: 'Order Date',
    accessor: 'dateCreated',
    Cell: (cell: any) => (
      <>
        {handleValidDate(cell?.value)},
        <small className='text-muted'> {handleValidTime(cell?.value)}</small>
      </>
    )
  },

  {
    id: 11,
    Header: 'Payment Date',
    accessor: 'datePaid',
    Cell: (cell: any) => (
      <>
        {cell.value ? (
          <>
            {handleValidDate(cell.value)},
            <small className='text-muted'> {handleValidTime(cell.value)}</small>
          </>
        ) : (
          '---'
        )}
      </>
    )
  },

  {
    id: 12,
    Header: 'Lock Date',
    accessor: 'dateLimitForAutoStake',
    Cell: (cell: any) => {
      return <SetAutostakeDate {...cell.row.original} />;
    }
  },

  {
    id: 13,
    Header: 'Status',
    accessor: 'status',
    Cell: (cell: any) => {
      switch (cell.value) {
        case 1:
          return (
            <span className='badge text-uppercase badge-soft-warning'>
              PENDING
            </span>
          );

        case 2:
          return (
            <span className='badge text-uppercase badge-soft-success'>
              {calculationStatusForTable(cell.row.original.calculationStatus)}
            </span>
          );

        case 3:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED
            </span>
          );

        case 4:
          return (
            <span className='badge text-uppercase badge-soft-danger'>
              CANCELED BY USER
            </span>
          );
      }
    }
  }
];

const actionsColumn = {
  id: 14,
  Header: 'Actions',
  accessor: 'id',
  Cell: (cell: any) => <PackageOrdersActions {...cell} />
};

export const columns = permissions?.packagePaymentAdmin
  ? [...baseColumns, actionsColumn]
  : baseColumns;

// export const columns = permissions?.packagePaymentAdmin
//   ? [
//       {
//         id: 1,
//         Header: 'Order ID',
//         accessor: 'id',
//         Cell: (cell: any) => {
//           return cell?.value;
//         }
//       },
//       {
//         id: 2,
//         Header: 'User ID',
//         accessor: 'user',
//         Cell: (cell: any) => {
//           return (
//             <Link to={`/users/${cell.value.id}`} state={{ tab: '3' }}>
//               {cell.value.id}
//             </Link>
//           );
//         }
//       },
//       {
//         id: 3,
//         Header: 'User',
//         accessor: 'user',
//         Cell: (cell: any) => {
//           return (
//             <>
//               {cell.value.name} {cell.value.surname}
//             </>
//           );
//         }
//       },

//       {
//         id: 4,
//         Header: 'Package Name',
//         accessor: 'productName',
//         Cell: (cell: any) => {
//           return cell?.value;
//         }
//       },
//       {
//         id: 6,
//         Header: 'Amount',
//         accessor: 'price',
//         Cell: (cell: any) => {
//           return cell?.value
//             ? `${formatUSDNoDecimals(cell?.value)} USDT`
//             : '---';
//         }
//       },

//       {
//         id: 7,
//         Header: 'Payment address',
//         accessor: 'paymentAddress',
//         Cell: (cell: any) => {
//           return cell?.value;
//         }
//       },

//       {
//         id: 10,
//         Header: 'Order Date',
//         accessor: 'dateCreated',
//         Cell: (cell: any) => (
//           <>
//             {handleValidDate(cell?.value)},
//             <small className='text-muted'>
//               {' '}
//               {handleValidTime(cell?.value)}
//             </small>
//           </>
//         )
//       },

//       {
//         id: 11,
//         Header: 'Payment Date',
//         accessor: 'datePaid',
//         Cell: (cell: any) => (
//           <>
//             {cell.value ? (
//               <>
//                 {handleValidDate(cell.value)},
//                 <small className='text-muted'>
//                   {' '}
//                   {handleValidTime(cell.value)}
//                 </small>
//               </>
//             ) : (
//               '---'
//             )}
//           </>
//         )
//       },

//       {
//         id: 12,
//         Header: 'Lock Date',
//         accessor: 'dateLimitForAutoStake',
//         Cell: (cell: any) => {
//           return <SetAutostakeDate {...cell.row.original} />;
//         }
//       },

//       {
//         id: 13,
//         Header: 'Status',
//         accessor: 'status',
//         Cell: (cell: any) => {
//           switch (cell.value) {
//             case 1:
//               return (
//                 <span className='badge text-uppercase badge-soft-warning'>
//                   PENDING
//                 </span>
//               );

//             case 2:
//               return (
//                 <span className='badge text-uppercase badge-soft-success'>
//                   {calculationStatusForTable(
//                     cell.row.original.calculationStatus
//                   )}
//                 </span>
//               );

//             case 3:
//               return (
//                 <span className='badge text-uppercase badge-soft-danger'>
//                   CANCELED
//                 </span>
//               );

//             case 4:
//               return (
//                 <span className='badge text-uppercase badge-soft-danger'>
//                   CANCELED BY USER
//                 </span>
//               );
//           }
//         }
//       },

//       {
//         id: 14,
//         Header: 'Actions',
//         accessor: 'id',
//         Cell: (cell: any) => {
//           return <PackageOrdersActions {...cell} />;
//         }
//       }
//     ]
//   : [
//       {
//         id: 1,
//         Header: 'Order ID',
//         accessor: 'id',
//         Cell: (cell: any) => {
//           return cell?.value;
//         }
//       },
//       {
//         id: 2,
//         Header: 'User ID',
//         accessor: 'user',
//         Cell: (cell: any) => {
//           return (
//             <Link to={`/users/${cell.value.id}`} state={{ tab: '3' }}>
//               {cell.value.id}
//             </Link>
//           );
//         }
//       },
//       {
//         id: 3,
//         Header: 'User',
//         accessor: 'user',
//         Cell: (cell: any) => {
//           return (
//             <>
//               {cell.value.name} {cell.value.surname}
//             </>
//           );
//         }
//       },

//       {
//         id: 4,
//         Header: 'Package Name',
//         accessor: 'productName',
//         Cell: (cell: any) => {
//           return cell?.value;
//         }
//       },
//       {
//         id: 6,
//         Header: 'Amount',
//         accessor: 'price',
//         Cell: (cell: any) => {
//           return cell?.value
//             ? `${formatUSDNoDecimals(cell?.value)} USDT`
//             : '---';
//         }
//       },

//       {
//         id: 7,
//         Header: 'Payment address',
//         accessor: 'paymentAddress',
//         Cell: (cell: any) => {
//           return cell?.value;
//         }
//       },

//       {
//         id: 10,
//         Header: 'Order Date',
//         accessor: 'dateCreated',
//         Cell: (cell: any) => (
//           <>
//             {handleValidDate(cell?.value)},
//             <small className='text-muted'>
//               {' '}
//               {handleValidTime(cell?.value)}
//             </small>
//           </>
//         )
//       },

//       {
//         id: 11,
//         Header: 'Payment Date',
//         accessor: 'datePaid',
//         Cell: (cell: any) => (
//           <>
//             {cell.value ? (
//               <>
//                 {handleValidDate(cell.value)},
//                 <small className='text-muted'>
//                   {' '}
//                   {handleValidTime(cell.value)}
//                 </small>
//               </>
//             ) : (
//               '---'
//             )}
//           </>
//         )
//       },

//       {
//         id: 12,
//         Header: 'Lock Date',
//         accessor: 'dateLimitForAutoStake',
//         Cell: (cell: any) => {
//           return <SetAutostakeDate {...cell.row.original} />;
//         }
//       },

//       {
//         id: 13,
//         Header: 'Status',
//         accessor: 'status',
//         Cell: (cell: any) => {
//           switch (cell.value) {
//             case 1:
//               return (
//                 <span className='badge text-uppercase badge-soft-warning'>
//                   PENDING
//                 </span>
//               );

//             case 2:
//               return (
//                 <span className='badge text-uppercase badge-soft-success'>
//                   {calculationStatusForTable(
//                     cell.row.original.calculationStatus
//                   )}
//                 </span>
//               );

//             case 3:
//               return (
//                 <span className='badge text-uppercase badge-soft-danger'>
//                   CANCELED
//                 </span>
//               );

//             case 4:
//               return (
//                 <span className='badge text-uppercase badge-soft-danger'>
//                   CANCELED BY USER
//                 </span>
//               );
//           }
//         }
//       }
//     ];
